// Exemplo básico para FCM com Firebase Web
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDhlNIIccdJuiRvS4XbJY8OLvp_-EtU6Rw",
  authDomain: "pwa-kids.firebaseapp.com",
  projectId: "pwa-kids",
  storageBucket: "pwa-kids.appspot.com",
  messagingSenderId: "762170424048",
  appId: "1:762170424048:web:86202a5c5ddddb9090a035",
  measurementId: "G-E2JLZ190EW",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
